import Marquee from "react-fast-marquee";

const ITEMS = ["T G P H O T O S H O P", "FINE ART PHOTOGRAPHY", "LICENSED DIGITAL PRINTS", "LIGHT, HELD FOREVER"];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="bg-black border-y border-white/10 py-5 overflow-hidden">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {ITEMS.map((text, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-sm tracking-[0.4em] text-zinc-500 mx-8">{text}</span>
            <span className="text-[#D4AF37] text-xs mx-2">—</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
